import React, { createContext, useContext, ReactNode } from 'react';
import i18n from '../utils/i18n.ts';
import { I18nextProvider } from 'react-i18next';
import { i18n as I18nInstance } from 'i18next';

interface I18nContextValue {
  i18n: I18nInstance;
}

interface I18nProviderProps {
  children: ReactNode;
}

const I18nContext = createContext<I18nContextValue | undefined>(undefined);

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <I18nContext.Provider value={{ i18n }}>
        {children}
      </I18nContext.Provider>
    </I18nextProvider>
  );
};

export const useI18nContext = (): I18nContextValue => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18nContext must be used within an I18nProvider');
  }
  return context;
};